import React from "react";
import PropTypes from "prop-types";
import AboutPage from "./abouts/about_page";
import MyAboutPage from "./abouts/my_about_page";

function AboutComponent(props) {
  const { is_mypage } = props;
  const isAboutShow = () => {
    const { profile, angel } = props;
    if (profile.bio || angel.interest || angel.investment_trend) {
      return true;
    } else {
      return false;
    }
  };

  return is_mypage === true ?
    <MyAboutPage isAboutShow={isAboutShow} {...props} />
    :
    <AboutPage isAboutShow={isAboutShow} {...props} />;
}

AboutComponent.propTypes = {
  is_mypage: PropTypes.bool.isRequired,
  profile: PropTypes.shape({
    bio: PropTypes.string
  }).isRequired,
  angel: PropTypes.shape({
    interest: PropTypes.string,
    investment_trend: PropTypes.string
  }).isRequired
};

export default AboutComponent;
